var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"s-vstack"},[_c('Table'),_c('ChainEditor',{on:{"edit":function($event){return _vm.$emit('edit', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }